module.exports = __webpack_public_path__ + "assets/img/d2ec10756cbfd270928a23309839c905.svg";